export default [{
  name: 'cityAirportForPx',
  method: 'get',
  desc: '获取国内机场',
  path: '/baseData/js/cityAirportForPx.js',
  serveType: 'nginx',
  params: {}
},{
  name: 'gjHotCityByDq',
  method: 'get',
  desc: '获取国际机场州分类',
  path: '/baseData/js/gjHotCityByDq.js',
  serveType: 'nginx',
  params: {}
},  {
  name: 'findTkHotCityList',
  method: 'get',
  desc: '获取国内热门机场',
  path: '/obt/findTkHotCityList',
  params: {},
  loading:'0'
},{
  name: 'listGroupByTag',
  method: 'post',
  desc: '获取所有热门',
  path: '/obt/bdc/geo/listGroupByTag',
  params: {
    cplx: '',
    international: '',
    urlType: '',
  },
  loading:'0'
},{
  name: 'getGjAirportData',
  method: 'post',
  desc: '获取国际机场',
  path: '/obt/getGjAirportData',
  params: {
    count: 1999,
    pyjsm: '',
    keywords: ''
  }
}, {
  name: 'getGjCityData',
  method: 'post',
  desc: '获取国际热门机场',
  path: '/obt/getGjCityData',
  params: {
    count: 20
  }
}, {
  name: 'bcity',
  method: 'get',
  desc: '获取酒店城市',
  path: '/baseData/js/bcity.js',
  serveType: 'nginx',
  params: {}
}, {
  name: 'cityStationH5',
  method: 'get',
  desc: '获取火车站',
  path: '/baseData/js/cityStationH5.js?t='+Date.now(),
  serveType: 'nginx',
  params: {}
}, {
  name: 'trainCity',
  method: 'get',
  desc: '获取热门火车站',
  path: '/baseData/js/trainCity.js?t='+Date.now(),
  params: {
    count: 20
  },
  serveType: 'nginx'
},{
  name: 'findHot',
  method: 'post',
  desc: '获取国内热门火车站点 新',
  path: '/obt/trainZd/findHot',
  params: {},
  loading:'0'
},
{
  name: 'proCity',
  method: 'get',
  desc: '获取省份城市',
  path: '/baseData/js/proCity.js',
  serveType: 'nginx'
}
// /obt/bdc/plane/findAirportByKeyword
// 机场搜索控件接口
, {
  name: 'findAirportByKeyword',
  method: 'get',
  desc: '机场搜索控件接口',
  path: '/obt/bdc/plane/findAirportByKeyword',
  params: {
    keyword: '',
    international:''
  },
}
// 国际机场数据根据国家分组
// / obt / getGjAirportDataGroupNation
, {
  name: 'getGjAirportDataGroupNation',
  method: 'post',
  desc: '国际机场数据根据国家分组',
  path: '/obt/getGjAirportDataGroupNation',
  params: {
    'count': 10,
    'keywords': '',
    'pageNum': 1,
    'pyjsm': ''
  }
}
// GET /obt/bdc/train/findTrainZdByKeyword
// 根据关键字获取火车站信息
, {
  name: 'findTrainZdByKeyword',
  method: 'get',
  desc: '根据关键字获取火车站信息',
  path: '/obt/bdc/train/findTrainZdByKeyword',
  params: {
    keyword:''
  }
},
{
  name: 'gjCity',
  method: 'get',
  desc: '获取国际城市热门以州分类',
  path: '/baseData/js/gjCity.js',
  serveType: 'nginx',
  params: {}
},
{
  name: 'gjBcity',
  method: 'get',
  desc: '获取国际城市',
  path: '/baseData/js/gjBcity.js',
  serveType: 'nginx',
  params: {}
},
{
  name: 'baiduPlace',
  method: 'get',
  desc: '获取国际城市',
  path: '/obt/baidu/baiduPlace',
  params: {
    cityName: '',
    keywords:''
  }
},
{
  name: 'geo_10901_zh-CN',
  method: 'get',
  desc: '国内机场',
  path: '/baseData/js/geo_10901_zh-CN.js',
  serveType: 'nginx',
  params: {}
},
{
  name: 'geo_10901_en-US',
  method: 'get',
  desc: '国内机场',
  path: '/baseData/js/geo_10901_en-GB.js',
  serveType: 'nginx',
  params: {}
},
{
  name: 'geo_10903_zh-CN',
  method: 'get',
  desc: '国内聚合酒店城市',
  path: '/baseData/js/geo_10903_zh-CN.js',
  serveType: 'nginx',
  params: {}
},
{
  name: 'geo_10903_other_zh-CN',
  method: 'get',
  desc: '国内城市',
  path: '/baseData/js/geo_10903_other_zh-CN.js',
  serveType: 'nginx',
  params: {}
},
{
  name: 'geo_10903_en-US',
  method: 'get',
  desc: '国内城市',
  path: '/baseData/js/geo_10903_en-GB.js',
  serveType: 'nginx',
  params: {}
},

{
  name: 'geo_10904_zh-CN',
  method: 'get',
  desc: '国内车站',
  path: '/baseData/js/geo_10904_zh-CN.js?t='+Date.now(),
  serveType: 'nginx',
  params: {}
},
{
  name: 'geo_10904_en-US',
  method: 'get',
  desc: '国内车站',
  path: '/baseData/js/geo_10904_en-GB.js?t='+Date.now(),
  serveType: 'nginx',
  params: {}
},
{
  name: 'geo_10910_zh-CN',
  method: 'get',
  desc: '国际城市',
  path: '/baseData/js/geo_10910_zh-CN.js',
  serveType: 'nginx',
  params: {}
},
{
  name: 'geo_109010_en-US',
  method: 'get',
  desc: '国际城市',
  path: '/baseData/js/geo_10910_en-GB.js',
  serveType: 'nginx',
  params: {}
},
{
  name: 'geo_10906_zh-CN',
  method: 'get',
  desc: '国际城市',
  path: '/baseData/js/geo_10906_zh-CN.js',
  serveType: 'nginx',
  params: {}
},
{
  name: 'geo_109006_en-US',
  method: 'get',
  desc: '国际城市',
  path: '/baseData/js/geo_10906_en-GB.js',
  serveType: 'nginx',
  params: {}
},
{
  name: 'findByKeyword',
  method: 'post',
  desc: '获取国际城市',
  path: '/obt/bdc/geo/findByKeyword',
  params: {
    cplx: '',
    keyword:''
  }
},
  ,
  {
    name: 'findLocationList',
    method: 'post',
    desc: '获取行政区',
    path: '/obt/bdc/findLocationList',
    params: {
      geoName:'',
    },
  },
]
